class JumpLinks extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.carousel = this.querySelector("[data-jumplinks-carousel]");

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this.initFunction();
    });
  }

  initFunction() {
    if (!this.carousel) return;

    const { Swiper } = this.swiperLib;

    this.swiper = new Swiper(this.carousel, {
      touchEventsTarget: 'container',
      spaceBetween: 10,
      slidesPerView: 2.4,
      grabCursor: true,
      mousewheelControl: true,
      breakpoints: {
        992: {
          slidesPerView: 5,
          spaceBetween: 35,
        }
      }
    });


    const sectionList = document.querySelectorAll('.shopify-section');

    const jumpLinkList = document.querySelectorAll('.link__anchor');
    jumpLinkList.forEach(link => {
      let linkNumber = link.dataset.link;
      linkNumber--;
      const linkTarget = sectionList[linkNumber].id;
      link.href = `#${linkTarget}`;
    });

  }
}

if (!customElements.get("section-jumplinks")) {
  customElements.define(
    "section-jumplinks",
    JumpLinks
  );
}
